import { get, post } from "./http";
const apiSDK = 'https://api.godsarrive.com/v1';
const apiOffical = 'https://game.godsarrive.com/api';

// const apiSDK = 'http://192.168.20.189:8084/v1';
// const apiOffical = 'http://192.168.20.189:1234';
// const apiOffical = 'https://test.godsarrive.com/api';
// 测试获取服务器列表使用
// const test = "http://192.168.5.157:1234"

export const api = {
    // 账号登陆
    login(data) {
        return post(apiSDK + '/member/signin', data)
    },
    // 账号注册
    register(data) {
        return post(apiSDK + '/member/signup', data)
    },
    // token验证登录状态
    tokenLogin(data) {
        return post(apiSDK + '/member/verify', data)
    },
    // 谷歌登陆
    googleLogin(data) {
        return post(apiOffical + '/member/google_jwt', data)
    },
    // facebook登陆
    facebookLogin(data) {
        return post(apiOffical + '/member/facebook', data)
    },
    // 苹果登陆
    appleLogin(data) {
        return post(apiOffical + '/member/apple', data)
    },
    //服务器列表
    gameList(data) {
        return get(apiOffical + '/game/webapp', data)
    },

    //服务器列表
    serverList(data) {
        return post(apiOffical + '/game/servers', data)

    },
    //角色列表
    roleList(data) {
        return post(apiOffical + '/game/roles', data)
    },
    // 确认订单状态
    orderStatus(data) {
        return post(apiOffical + '/order/query', data)
    },
    //元宝商品列表
    productsList(data) {
        return post(apiOffical + '/game/webproducts', data)
    },
    //产品返利金额
    rebatesList(data) {
        return post(apiOffical + '/game/rebates', data)
    },
    travelletPay(d) {
        return post(apiOffical + '/travellet/pay', d)
    },
    pay(d) {
        return post(apiOffical + '/game/pay', d)
    }
}